import './signatureInput.scss';

import * as React from 'react';
import SignatureCanvas from 'react-signature-canvas';

import { base64ToFile } from '../../../utils/generalUtils';
import { Icon } from '../Icon';

export interface ISignatureInputProps {
    onSave?: Function;
}

export interface ISignatureInputState {
    signature: string;
    file: Blob;
}

export class SignatureInput extends React.PureComponent<ISignatureInputProps, ISignatureInputState> {
    constructor(props: ISignatureInputProps) {
        super(props);
        this.state = { signature: null, file: null };
    }

    public refs: {
        acceptorSignature: SignatureCanvas;
    };

    get value() {
        return this.state.file;
    }

    public saveSignature = async () => {
        const acceptorSignature = this
            .refs
            .acceptorSignature.getTrimmedCanvas()
            .toDataURL();
        const self = this;
        this.props.onSave(acceptorSignature);
        const fileObj = await base64ToFile(acceptorSignature, 'user-signature.png').then(function (file) {
            self.setState({
                file
            });
            return file;
        });
        this.setState({
            signature: acceptorSignature
        });
    }

    public handleSignatureDelete = () => {
        this.setState({
            signature: null,
            file: null
        });
    }

    public render() {
        return this.state.signature ?
            <div className="signature">
                <Icon icon="times" onClick={this.handleSignatureDelete} />
                <img src={this.state.signature} />
            </div> :
            <div className="signature-input" style={{ paddingBottom: '35px' }} >
                <div className="signature-container" >
                    <SignatureCanvas
                        clearOnResize={false}
                        key="pad"
                        canvasProps={{ width: 327, height: 150, className: 'sigCanvas' }}
                        ref="acceptorSignature" />
                    <div className="buttons-container" >
                        <button
                            type="button"
                            onClick={() => this.refs.acceptorSignature.clear()}
                            className="clear-button"
                        >
                            Clear
             </button>
                        <button
                            type="button"
                            className="save-button"
                            onClick={this.saveSignature} >
                            Save
             </button>
                    </div>
                </div >
            </div>;
    }
}
const newSignButton: React.CSSProperties = {
    color: 'white',
    border: 'none',
    backgroundColor: '#88ceb2',
    width: '75px',
    borderRadius: '5px',
    padding: '5px 0'
};

const autoSignButton: React.CSSProperties = {
    color: 'white',
    border: 'none',
    backgroundColor: '#88ceb2',
    borderRadius: '5px',
    padding: '5px 15px',
    marginTop: '10px'
};

const newSign: React.CSSProperties = {
    border: 'none',
    color: 'white',
    background: '#88ceb2',
    marginTop: '10px',
    width: '93px',
    borderRadius: '5px'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/SignatureInput/index.tsx